import { MutationTree } from 'vuex';
import { State } from './state';
import { ModalMutationTypes } from './mutation-types';
import { eTipoPesquisaFiltroFuncionarios } from "@/enums/eTipoPesquisaFiltroFuncionarios";
import { eTipoPesquisaFiltroEstudantes } from "@/enums/eTipoPesquisaFiltroEstudantes";
import { eTipoPesquisaFiltroTurmas } from "@/enums/eTipoPesquisaFiltroTurmas";

export type Mutations<S = State> = {
  [ModalMutationTypes.ACTION_SHOW_MODAL_FILTRO_FUNCIONARIO](state: S): void;
  [ModalMutationTypes.ACTION_HIDE_MODAL_FILTRO_FUNCIONARIO](state: S): void;
  [ModalMutationTypes.ACTION_SHOW_MODAL_LEGADO](state: S): void;
  [ModalMutationTypes.ACTION_HIDE_MODAL_LEGADO](state: S): void;
  [ModalMutationTypes.ACTION_SHOW_MODAL_AVISOS_NOTIFICACOES](state: S): void;
  [ModalMutationTypes.ACTION_HIDE_MODAL_AVISOS_NOTIFICACOES](state: S): void;
  [ModalMutationTypes.SET_CODIGOPROFESSOR_SELECIONADO_TELA_FILTRO](state: S, codigoProfessorSelectedTelaFiltro: number): void;
  [ModalMutationTypes.SET_NOMEPROFESSOR_SELECIONADO_TELA_FILTRO](state: S, nomeProfessorSelectedTelaFiltro: string): void;
  [ModalMutationTypes.RESET_PROFESSOR_SELECIONADO_TELA_FILTRO](state: S): void;
  [ModalMutationTypes.SET_TIPOPESQUISA_TELA_FILTRO_FUNCIONARIOS](state: S, enumTipoPesquisaFiltroFuncionarios: eTipoPesquisaFiltroFuncionarios): void;
  [ModalMutationTypes.SET_ROTA_CHAMAR_FILTRO_FUNCIONARIOS](state: S, route: string): void;
  [ModalMutationTypes.ACTION_SHOW_MODAL_FILTRO_ESTUDANTE](state: S): void;
  [ModalMutationTypes.ACTION_HIDE_MODAL_FILTRO_ESTUDANTE](state: S): void;
  [ModalMutationTypes.SET_CODIGOESTUDANTE_SELECIONADO_TELA_FILTRO](state: S, codigoEstudante: number): void;
  [ModalMutationTypes.SET_ROTA_CHAMAR_FILTRO_ESTUDANTES](state: S, route: string): void;
  [ModalMutationTypes.SET_TIPOPESQUISA_TELA_FILTRO_ESTUDANTES](state: S, tipoPesquisa: eTipoPesquisaFiltroEstudantes): void; // Adicione o tipo correto caso exista outro para estudantes
  [ModalMutationTypes.ACTION_SHOW_MODAL_FILTRO_TURMA](state: S): void;
  [ModalMutationTypes.ACTION_HIDE_MODAL_FILTRO_TURMA](state: S): void;
  [ModalMutationTypes.ACTION_SHOW_MODAL_FILTRO_MULTI_TURMA](state: S): void;
  [ModalMutationTypes.ACTION_HIDE_MODAL_FILTRO_MULTI_TURMA](state: S): void;
  [ModalMutationTypes.SET_CODIGOTURMA_SELECIONADA_TELA_FILTRO](state: S, codigoTurma: string): void;
  [ModalMutationTypes.SET_ROTA_CHAMAR_FILTRO_TURMAS](state: S, route: string): void;
  [ModalMutationTypes.SET_TIPOPESQUISA_TELA_FILTRO_TURMAS](state: S, tipoPesquisa: eTipoPesquisaFiltroTurmas): void;
}


export const mutations: MutationTree<State> & Mutations = {
  [ModalMutationTypes.ACTION_SHOW_MODAL_FILTRO_FUNCIONARIO](state: State) {
    state.showModal = true;
  },
  [ModalMutationTypes.ACTION_HIDE_MODAL_FILTRO_FUNCIONARIO](state: State) {
    state.showModal = false;
  },
  [ModalMutationTypes.ACTION_SHOW_MODAL_LEGADO](state: State) {
    state.showModalLegado = true;
  },
  [ModalMutationTypes.ACTION_HIDE_MODAL_LEGADO](state: State) {
    state.showModalLegado = false;
  },
  [ModalMutationTypes.ACTION_SHOW_MODAL_AVISOS_NOTIFICACOES](state: State) {
    state.showModalAvisosNotificacoes = true;
  },
  [ModalMutationTypes.ACTION_HIDE_MODAL_AVISOS_NOTIFICACOES](state: State) {
    state.showModalAvisosNotificacoes = false;
  },
  [ModalMutationTypes.SET_CODIGOPROFESSOR_SELECIONADO_TELA_FILTRO](state: State, codigoProfessorSelectedTelaFiltro: number) {
    state.codigoProfessorSelectedTelaFiltro = codigoProfessorSelectedTelaFiltro;
  },
  [ModalMutationTypes.SET_NOMEPROFESSOR_SELECIONADO_TELA_FILTRO](state: State, nomeProfessorSelectedTelaFiltro: string) {
    state.nomeProfessorSelectedTelaFiltro = nomeProfessorSelectedTelaFiltro;
  },
  [ModalMutationTypes.SET_TIPOPESQUISA_TELA_FILTRO_FUNCIONARIOS](state: State, eTipoPesquisaFiltroFuncionarios: eTipoPesquisaFiltroFuncionarios) {
    state.enumTipoPesquisaFiltroFuncionarios = eTipoPesquisaFiltroFuncionarios;
  },
  [ModalMutationTypes.SET_ROTA_CHAMAR_FILTRO_FUNCIONARIOS](state: State, route: string) {
    state.routeAfterSelectFiltroFuncionarios = route;
  },
  [ModalMutationTypes.ACTION_SHOW_MODAL_FILTRO_ESTUDANTE](state: State) {
    state.showModalFiltroEstudantes = true;
  },
  [ModalMutationTypes.ACTION_HIDE_MODAL_FILTRO_ESTUDANTE](state: State) {
    state.showModalFiltroEstudantes = false;
  },
  [ModalMutationTypes.ACTION_SHOW_MODAL_FILTRO_TURMA](state: State) {
    state.showModalFiltroTurmas = true;
  },
  [ModalMutationTypes.ACTION_HIDE_MODAL_FILTRO_TURMA](state: State) {
    state.showModalFiltroTurmas = false;
  },
  [ModalMutationTypes.ACTION_SHOW_MODAL_FILTRO_MULTI_TURMA](state: State) {
    state.showModalFiltroMultiTurmas = true;
  },
  [ModalMutationTypes.ACTION_HIDE_MODAL_FILTRO_MULTI_TURMA](state: State) {
    state.showModalFiltroMultiTurmas = false;
  },
  [ModalMutationTypes.SET_CODIGOESTUDANTE_SELECIONADO_TELA_FILTRO](state: State, codigoEstudante: number) {
    state.codigoEstudanteSelectedTelaFiltro = codigoEstudante;
  },
  [ModalMutationTypes.SET_ROTA_CHAMAR_FILTRO_ESTUDANTES](state: State, route: string) {
    state.routeAfterSelectFiltroEstudantes = route;
  },
  [ModalMutationTypes.SET_TIPOPESQUISA_TELA_FILTRO_ESTUDANTES](state: State, eTipoPesquisaFiltroEstudantes: eTipoPesquisaFiltroEstudantes) {
    state.enumTipoPesquisaFiltroEstudantes = eTipoPesquisaFiltroEstudantes;
  },
  [ModalMutationTypes.SET_CODIGOTURMA_SELECIONADA_TELA_FILTRO](state: State, codigoTurma: string) {
    state.codigoTurmaSelectedTelaFiltro = codigoTurma;
  },
  [ModalMutationTypes.SET_ROTA_CHAMAR_FILTRO_TURMAS](state: State, route: string) {
    state.routeAfterSelectFiltroTurmas = route;
  },
  [ModalMutationTypes.SET_TIPOPESQUISA_TELA_FILTRO_TURMAS](state: State, eTipoPesquisaFiltroTurmas: eTipoPesquisaFiltroTurmas) {
    state.enumTipoPesquisaFiltroTurmas = eTipoPesquisaFiltroTurmas;
  },
  [ModalMutationTypes.RESET_PROFESSOR_SELECIONADO_TELA_FILTRO](state: State) {
    state.codigoProfessorSelectedTelaFiltro = 0;
    state.nomeProfessorSelectedTelaFiltro = '';
  },
};
